function ControlGroup(name) {
    this.name = name;
}

ControlGroup.DEFAULT = new ControlGroup("default");

module.exports = ControlGroup;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/control/control-group.js
// module id = 278
// module chunks = 1